import firebase from "firebase";
import "firebase/auth";

// if (typeof window !== "undefined" && !firebase.apps.length) {
//     firebase.initializeApp({
//         apiKey: "AIzaSyC-Jna5XTa18AO8iGSK-zUZ-6SexWc3ZLU",
//         authDomain: "nec-bi-dev.firebaseapp.com",
//         databaseURL: "https://nec-bi-dev.firebaseio.com",
//         projectId: "nec-bi-dev",
//         storageBucket: "nec-bi-dev.appspot.com",
//         messagingSenderId: "678634054043",
//         appId: "1:678634054043:web:b654de9fbed3c5860a413e",
//     });

//     firebase.auth().languageCode = "vi";
// }

if (typeof window !== "undefined" && !firebase.apps.length) {
  firebase.initializeApp({
    apiKey: "AIzaSyDXUBgip3U_MKhnrA0NDhjuXrgo-IvQPkU",
    authDomain: "chiyoda-membership.firebaseapp.com",
    projectId: "chiyoda-membership",
    storageBucket: "chiyoda-membership.firebasestorage.app",
    messagingSenderId: "414009050012",
    appId: "1:414009050012:web:145ad858ef05ff3416be59",
    measurementId: "G-D2TLNT2RR6"
  });
  firebase.auth().languageCode = "vi";
}

export { firebase };
